import { render, staticRenderFns } from "./DistributionListEditor.vue?vue&type=template&id=34dd93a5&scoped=true&"
import script from "./DistributionListEditor.vue?vue&type=script&lang=js&"
export * from "./DistributionListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dd93a5",
  null
  
)

export default component.exports